<template>
    <RouterLink v-if="!disabled" :to="to">
        <Button v-bind="$attrs" :icon="icon" :label="label" :text="text" :severity="severity" :size="size" />
    </RouterLink>
    <Button v-else v-bind="$attrs" :icon="icon" :label="label" :text="text" :severity="severity" :size="size"
        :disabled="disabled" />
</template>

<script setup lang="ts">
import Button from 'primevue/button'
import type { RouteLocationRaw } from 'vue-router'

defineProps<{
    to: RouteLocationRaw
    label?: string
    icon?: string
    text?: boolean
    severity?: string
    size?: 'small' | 'large' | undefined
    disabled?: boolean
}>()
</script>

<style scoped></style>
